// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__AsC7J","title":"styles_title__VUb7X"};